import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Rocket"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M5.4663 17.469L11.464 11.4713L12.5245 12.5318L6.5268 18.5295L5.4663 17.469ZM12.7504 22.5C12.6554 22.5003 12.5612 22.4825 12.4729 22.4475C12.2227 22.3478 12.0453 22.1217 12.0079 21.855L11.2579 16.605L12.7579 16.395L13.3204 20.3475L15.7504 18.39V12.75C15.7492 12.5507 15.8275 12.3591 15.9679 12.2175L19.0204 9.16505C20.2908 7.90322 21.0038 6.18565 21.0004 4.39505V3.00005H19.6054C17.8148 2.99664 16.0972 3.7096 14.8354 4.98005L11.7829 8.03255C11.6413 8.17294 11.4497 8.2512 11.2504 8.25005H5.61036L3.65286 10.695L7.60536 11.2575L7.39536 12.7575L2.14536 12.0075C1.87871 11.9701 1.65257 11.7927 1.55286 11.5425C1.45189 11.2906 1.49492 11.0038 1.66536 10.7925L4.66536 7.04255C4.80534 6.86068 5.02088 6.75291 5.25036 6.75005H10.9429L13.7704 3.91505C15.3143 2.3624 17.4157 1.49267 19.6054 1.50005H21.0004C21.8288 1.50005 22.5004 2.17162 22.5004 3.00005V4.39505C22.5077 6.58468 21.638 8.68608 20.0854 10.23L17.2504 13.0575V18.75C17.2493 18.9783 17.1444 19.1936 16.9654 19.335L13.2154 22.335C13.0834 22.4409 12.9195 22.4991 12.7504 22.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Rocket.vue"]]);
